// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"48":"20bb34","210":"21708f","572":"019a5a"}[chunkId] + ".js";
};